<script>
import { mapActions } from "vuex";
import Modal from "@/components/_Shared/Modal";
import InputGroup from "@/components/_Shared/InputGroup";

export default {
  components: {
    Modal,
    InputGroup
  },

  data() {
    return {
      preloader: false,
      email: "",
      data: {
        relationships: {
          account: {
            attributes: {
              email: "",
              first_name: "",
              last_name: "",
              password: "",
              password_confirmation: ""
            },
            relationships: {
              profile: {
                attributes: {
                  city_name: "",
                  state_name: "",
                  occupation: ""
                }
              }
            }
          }
        }
      }
    };
  },

  watch: {
    email(val) {
      let valid = val.split("@");
      this.data.relationships.account.attributes.email =
        valid[0] + "@donamaid.com";
    }
  },

  methods: {
    ...mapActions("donamakers", ["create"]),

    async submit() {
      this.preloader = true;

      try {
        let valid = await this.$validator.validateAll();

        if (valid) {
          await this.create(this.data);
          this.$emit("close");
          this.$emit("refresh");
        }
      } catch (error) {
        error.forEach(el => {
          let field = el.detail.split(" - ");

          this.$validator.errors.add({
            field: field[0],
            msg: el.title
          });
        });
      }

      this.preloader = false;
    }
  }
};
</script>

<template>
  <modal
    title="NOVO DONAMAKER"
    subtitle="Cadastre um novo donamaker"
    size="md"
    @close="$emit('close')"
  >
    <template slot="body">
      <div class="form-group">
        <InputGroup
          :error="errors.first('nome')"
          v-validate.disabled="'required|alpha_spaces'"
          v-model="data.relationships.account.attributes.first_name"
          label="nome"
          custom-classes="capitalize"
        />

        <InputGroup
          :error="errors.first('sobrenome')"
          v-validate.disabled="'required|alpha_spaces'"
          v-model="data.relationships.account.attributes.last_name"
          label="sobrenome"
          custom-classes="capitalize"
        />
      </div>

      <div class="form-group">
        <InputGroup
          :error="errors.first('email')"
          v-validate.disabled="'required'"
          v-model="email"
          addon="@donamaid.com"
          label="email"
        />

        <InputGroup
          :error="errors.first('cargo')"
          v-validate.disabled="'required'"
          v-model="data.relationships.account.relationships.profile.attributes.occupation"
          label="cargo"
        />
      </div>

      <div class="form-group">
        <InputGroup
          :error="errors.first('cidade')"
          v-validate.disabled="'required|alpha_spaces'"
          v-model="data.relationships.account.relationships.profile.attributes.city_name"
          label="cidade"
        />

        <InputGroup
          :error="errors.first('uf')"
          v-validate.disabled="'required|alpha|length:2'"
          v-model="data.relationships.account.relationships.profile.attributes.state_name"
          label="uf"
        />
      </div>

      <div class="form-group">
        <InputGroup
          :error="errors.first('senha')"
          v-validate.disabled="'required|min:8'"
          v-model="data.relationships.account.attributes.password"
          label="senha"
          type="password"
          ref="senha"
        />

        <InputGroup
          :error="errors.first('confirme a senha')"
          v-validate.disabled="'required|min:8|confirmed:senha'"
          v-model="data.relationships.account.attributes.password_confirmation"
          label="confirme a senha"
          type="password"
        />
      </div>
    </template>

    <template slot="footer">
      <button class="btn bg-purple-outline" @click="$emit('close')">fechar</button>
      <button class="btn bg-purple" :class="{'btn--loading': preloader}" @click="submit">
        <span>cadastrar</span>
      </button>
    </template>
  </modal>
</template>



// WEBPACK FOOTER //
// src/components/Donamakers/NewDonamaker.vue